import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#949ba7",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 2.75586V8.75586M3.5 6.74414L6 9.24414L8.5 6.74414",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSort;
